export const DEV_ENV_NAME = 'dev';


